import React from "react";
import OrderNote from "./BookModule.module.css";
import CheckCircle from "./CheckCircleIcon.png";

export default function OrderSuccessNote(props) {
  return (
    <div
      className={`${OrderNote.orderSuccessSec} d-flex flex-column align-items-center`}
    >
      <img
        src={CheckCircle}
        className={OrderNote.CheckSuccessImage}
        alt="Success Image"
      />
      <p className={`${OrderNote.orderSuccessLabel} pb-0 padding_10_0 mb-0`}>
        {props.deliveryMode == 1
          ? `Your order for the books listed below has been successfully placed.
      The estimated delivery date is  ${
        props.ExpectedDate ? props.ExpectedDate : "_"
      }.`
          : `Your order for the books listed below has been successfully placed. You
        can pick up your books from the selected branch before
        ${props.ExpectedDate ? props.ExpectedDate : "_"}.`}
      </p>
      <p className={`${OrderNote.orderSuccessLabel} pt-0 padding_0 mb-0`}>
        {`In case of e-books, you can now download by clicking the “Download This E-book” button below. Please note that the download is available only once`}
      </p>
      <p className={`${OrderNote.orderSuccessLabel} pt-0 padding_10_0 mb-0`}>
        {props.deliveryMode == 1
          ? `We wish you all the best in your preparation and success in your
      upcoming competitive exams!`
          : `We wish you the best of luck in your competitive exam preparations!`}
      </p>
    </div>
  );
}
